import i18n from '@/i18n'
import { SaasAxios } from '@quick/saas-axios'
import { isEduEnvSync } from '@util/edu'

/**
 * @description COMPANY_ERROR_CODE的映射，理由：创建企业新接口返回的error info与
 *  就接口不一致，所以需要进行映射兼容
 * */
export const COMPANY_ERROR_CODE_MAPPING = {
  40010016: 'CompCountFlow',
  // 加入企业数量超过限制
  42900001: 'apiRateLimitExceede',
  // 您的操作频率过快，请稍后重试
  40010019: 'ContainSensitiveText',
  // 不能使用违禁词 -- 输入名称不可用，请修改后重试
  40010104: 'CompanyNamelsAuthed', // 企业名称已被认证保护
}
export const UserLicense = {
  plus_company_create: {
    name: i18n.t('e6b7c4aa66'),
    link: `${SaasAxios.getHost('WPS')}/privacy/account/`,
  },
}
export const registerTitle = isEduEnvSync()
  ? i18n.t('595023d905')
  : i18n.t('ba8c2df551')
